import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { MobileStatusBox } from './MobileStatusBox';

/**
 * Connect-disabled variant of {@link MobilePrimaryDomainNotRegistered} - keeps
 * the subdomain-specific copy, drops the CTA.
 */
export const MobilePrimaryDomainNotRegisteredNoConnect = _ref => {
  let {
    domainName,
    datahook
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const parsedDomain = parseDomain(domainName ?? '');
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, t('domain_search_gate.mobile.error.subdomain.no_connect', {
    domainName: parsedDomain.main
  }));
};
//# sourceMappingURL=MobilePrimaryDomainNotRegisteredNoConnect.js.map